export default "__VITE_ASSET__00b54c8f__"